import React from 'react';
import { useRecoilState } from 'recoil';

import {
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { currentTeam } from '../../../recoil/atoms/currentTeam';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import {
  endpointEnum,
  makeApiRequestCached,
} from '../../../services/rest/makeAPIRequest';

const useStyles = makeStyles((theme) => ({
  teamDropdown: {
    marginLeft: '1vw',
    marginTop: '10px',
  },
}));

export interface IBusinessTeams {
  lastUpdated: string;
  memberCount: number;
  teamid: number;
  teamname: string;
}

export function TeamDropdown(props: {
  isSnapshot?: boolean;
  setSelectedTeamId?: (id: number) => void;
  setSelectedTeamName?: (name: string) => void;
}) {
  const { isSnapshot, setSelectedTeamId, setSelectedTeamName } = props;
  const classes = useStyles();
  const [businessTeamsCached] = makeApiRequestCached<IBusinessTeams[]>(
    {
      endpoint: endpointEnum.GET_BUSINESS_TEAMS,
      payloadJsonString: JSON.stringify({
        call: methodNameEnum.GET_BUSINESS_TEAMS,
      }),
    },
    (loadable, cached) =>
      Array.isArray(loadable.contents?.response?.data?.result)
        ? [...loadable.contents.response.data.result].sort((l, r) =>
            l?.teamname?.toLowerCase().localeCompare(r?.teamname?.toLowerCase())
          )
        : cached.current,
    [] // initialize cache
  );
  const [team, setTeam] = useRecoilState(currentTeam);
  function teamHandler(event: SelectChangeEvent | React.ChangeEvent<any>) {
    let [id, name] = event.target.value.split(',');
    id = parseInt(id);
    setSelectedTeamId?.(id);
    setSelectedTeamName?.(name);
    setTeam({
      id,
      name,
    });
  }
  return (
    <FormControl
      className={classes.teamDropdown}
      size="small"
      variant="outlined"
    >
      <InputLabel>Team</InputLabel>
      <Select
        defaultValue={`${team.id},${team.name}`}
        onChange={teamHandler}
        label="Team"
        native
        name="team-dropdown"
      >
        {isSnapshot ? (
          <option value={'0,All Agents'}>All Agents</option>
        ) : (
          <option value={'0,All Teams'}>All Teams</option>
        )}
        {businessTeamsCached.current.map((team, index) => (
          <option key={index} value={`${team.teamid},${team.teamname}`}>
            {team.teamname}
          </option>
        ))}
      </Select>
    </FormControl>
  );
}
